@if (isMobile) {
  <div id="horizontal-nav">
    <div id="horizontal-nav-header">
      <app-logo size="small" />
      <app-navbar-profile-info
        imageWidth="35px"
        imageHeight="35px"
        [showDetails]="false"
      ></app-navbar-profile-info>
    </div>
  </div>
} @else {
  <div id="user-layout" class="d-none d-md-block mb-4">
    <div class="container">
      <div class="row my-3 pe-3 nav-row">
        <div class="col col-auto d-lg-block d-none my-2">
          <app-navbar-profile-info></app-navbar-profile-info>
        </div>
      </div>
    </div>

    <app-logo />
  </div>
}

<div id="page-content">
  <router-outlet></router-outlet>
</div>
